<template>
  <EXDialog
    :title="title"
    :label="label"
    :showVisible="curShowChoose"
    width="70%"
    @close="closeFn"
  >
    <div style="display: flex; height: 90%">
      <div class="left-tree">
        <div class="search">
          <span style="width: 0.8rem; margin-right: 0.1rem;text-align: right;">{{ label }} :</span>
          <el-input
            v-model="keyWords"
            suffix-icon="el-icon-search"
            placeholder="可根据关键词过滤"
          ></el-input>
          <el-button
            type="primary"
            size="medium"
            style="min-width:.8rem;margin-left: 0.1rem"
            @click="resetKeyword"
            >重置</el-button
          >
        </div>
        <div style="width: 100%; height: calc(100% - 30px)">
          <ETree
            ref="fatherTree"
            :treeList="treeList"
            :ifEditMenu="false"
            nodeWidth="100%"
            treeHeight="100%"
            @fetchTableData="clickNode"
          />
        </div>
      </div>
      <div class="right-trans">
        <div class="checked-per">已选人员：{{ checkedPerson }}</div>
        <el-transfer
          filterable
          filter-placeholder="请输入人员名单"
          v-model="checkedKey"
          :titles="['待选', '已选']"
          :props="defaultProps"
          :data="personList"
          @change="choosePerson"
        >
        </el-transfer>
      </div>
    </div>
    <div class="footer">
      <el-button type="primary" size="medium" @click="sureFn">确定</el-button>
      <el-button type="primary" size="medium" plain @click="closeFn">取消</el-button>
    </div>
  </EXDialog>
</template>

<script>
import ETree from "@/components/EXTree/tree.vue";
import EXDialog from "./index.vue";
import apiDict from '@/api/gate/apiDict'
export default {
  name: 'EXChoosePerson',
  props: {
    title: String,
    label: String,
    showChoose: Boolean,
    closeDilog: Function,
    sureSelect: Function,
    //父部门编码
    orgCode: Number,
    //部门树数据：优先于orgCode
    treeData:{
      type:Array,
      default: ()=>([])
    },
    //部门点击事件回调：当配置了personOrgCode初始化待选列表会根据此属性判断是调用父组件的自定义函数初始化部门人员列表还是自动查询系统用户列表
    clickUnit:Function,
    //初始化已选人员所在部门编码
    personOrgCode: Number,
    //初始化已选人员id逗号拼接字符串
    personId:String,
    //初始化已选人员姓名逗号拼接字符串
    personName:String,
  },
  components: {
    ETree,
    EXDialog
  },
  data() {
    return {
      keyWords: "",
      treeList: [],  //部门树
      timer: null,
      checkedKey: [],
      checkedPerson: [], // 人员名称
      personList: [], //人员列表
      defaultProps: {
        key: "key",
        label: "label",
      },
      checkedList: [] //已选人员列表
    };
  },
  watch: {
    keyWords: {
      handler() {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.handleSearch();
        }, 200);
      },
      deep: true,
    },
    treeData (val) {
      this.treeList = val;
    },
    personOrgCode(val){
      if(val){
        this.clickNode({treeKey:val})
      }
    },
    personId(val){
      if(val){
          this.handleChecked(val,this.personName)
      }
    },
    personName(val){
      if(val){
          this.handleChecked(this.personId,val)
      }
    }
  },
  computed:{
    curShowChoose(){
      return this.showChoose
    }
  },
  mounted(){
    if(this.orgCode && this.orgCode != ''){
      this.handleTreeDep()
    }
    if(this.treeData && this.treeData.length > 0){
      this.treeList = this.treeData;
    }
    this.handleChecked(this.personId,this.personName)
  },
  methods: {
    handleChecked(personId,personName){
      if(this.personOrgCode && this.personOrgCode != ''){  //初始化待选列表
        this.clickNode({treeKey:this.personOrgCode})
      }
      this.checkedKey = []
      this.checkedPerson = []
      this.checkedList = []
      if(personId){
        this.checkedKey = personId.split(",");
      }
      if(personName){
        this.checkedPerson = personName.split(",");
      }
      if(this.checkedKey && this.checkedKey.length > 0 && this.checkedPerson && this.checkedPerson.length > 0 && this.checkedKey.length == this.checkedPerson.length){
        for(let i = 0; i < this.checkedKey.length; i++){
           this.checkedList.push({key:this.checkedKey[i] ,label:this.checkedPerson[i]})
          }
      }
    },
    async handleTreeDep(){
        let res = await apiDict.getOrgCodeTree({orgCode:this.orgCode}) //树数据
        const body = res && res.body ? res.body : {}
        const list = body.treeList || []
        let treeList = this.modifyTreeConfigNoNumber(list)
        this.treeList = treeList   
        //默认点击第一个部门节点 暂放

    },
     //递归树构造
    modifyTreeConfigNoNumber(list){
      if(list!=null && list.length > 0){
        return list.map(e => ({ label: e.orgName, treeKey: e.orgId,children:this.modifyTreeConfigNoNumber(e.children),persons:e.persons}))
      }
    },
    filterMethod() {},
    handleSearch() {
      this.$refs.fatherTree.$refs.tree.filter(this.keyWords);
    },
    closeFn() {
      this.$emit("closeDilog");
    },
    //选择部门事件：根据部门ID刷新人员列表
    clickNode(item) {
      if (this.$listeners.clickUnit) {
        this.$emit('clickUnit',item)
        return;
      } 
      let size = item.persons==null||item.persons==undefined?0:item.persons.length  //获取人员数
      const params = {
        pageNo : 1,
        pageSize : size,
        orgId : item.treeKey,
        delFlag: '0'
      }
      apiDict.getPersonByOrgId(params).then(res=>{  
        const body = res && res.body ? res.body : {}
        const list = body.page.list || []
        this.personList = list.map(p => ({ label: p.personName, key: p.accountId}))
      })
    },
    resetKeyword() {
      this.keyWords = "";
    },
    sureFn() {
      if(!this.checkedList || this.checkedList.length == 0) {
        this.$emit("sureSelect","","");
      }else{
        this.$emit("sureSelect",this.checkedKey.join(),this.checkedPerson.join());
      }
    },
    choosePerson(val,type,key) {
      // this.checkedKey = []
      // this.checkedPerson = []
      // let rightPerson = this.personList.filter((item) => {
      //   return val.includes(item.key);
      // });
      // rightPerson.forEach(item => {
      //   this.checkedKey.push(item.key)
      //   this.checkedPerson.push(item.label)
      // })
        // console.log(value,type,key)
        if(type == 'right'){ //添加
            this.personList.forEach((item,index,arr) => {
              key.forEach(val => {
                if(item.key === val){
                  this.checkedList.push(item)
                }
              })
            })
      }else{//取消
        this.checkedList = this.checkedList.filter(item => !key.includes(item.key)) 
      }
      this.checkedKey = []
      this.checkedPerson = []
      this.checkedList.forEach(item => {
           this.checkedKey.push(item.key)
           this.checkedPerson.push(item.label)
      })
    },
    setPersonList(value){
      this.personList = value
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
/deep/ .el-dialog__body {
  height: calc(100% - .35rem);
}
.left-tree {
  width: 50%;
  padding-right: .1rem;
  .search {
    display: flex;
    align-items: center;
    .el-input{
      width: auto;
      // font-size: .16rem;
    }
  }
}
.right-trans {
  width: 50%;
  display: flex;
  flex-direction: column;
  padding-left: 0.1rem;
  border-left: 1px dashed #D9D9D9;
  .checked-per {
    line-height: 0.4rem;
  }
  /deep/ .el-input {
    width: 90%;
  }
  /deep/ .el-input__inner {
    padding-left: 0.4rem;
  }
  /deep/ .el-transfer-panel__filter {
    margin: 5%;
  }
}
.footer {
  text-align: right;
  margin-top: 0.2rem;
  .el-button{
    min-width: .8rem;
  }
}

/deep/ .el-dialog {
  height: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0 !important; // 覆盖15vh
}
/deep/ .el-transfer {
  width: 100%;
  height: calc(100% - 0.4rem);
  display: flex;
}
/deep/ .el-transfer-panel {
  width: 45%;
}
/deep/ .el-transfer__buttons {
  width: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .el-button:last-child {
    margin-left: 0;
  }
}

/deep/ .el-transfer-panel__header {
  height: 0.4rem;
  line-height: 0.4rem;
}
/deep/ .el-checkbox {
  line-height: 0.4rem !important;
}
/deep/ .el-checkbox__label {
  font-size: 0.16rem !important;
  color: #333 !important;
  font-weight: 400;
}
/deep/ .el-transfer-panel__body {
  height: calc(100% - 0.4rem);
}
/deep/ .el-checkbox-group {
  height: calc(100% - 0.2rem - 10%);
}
/deep/ .el-transfer-panel__item {
  display: block;
}
.el-transfer-panel__filter .el-input__icon{
  margin-left: 0;
}

/deep/ .el-transfer-panel .el-transfer-panel__header{
  @include tree_bg($tree-bgD);
}
</style>


// WEBPACK FOOTER //
// src/components/EXDialog/EXChoosePerson.vue